import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { EMPTY,  Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorLogService } from '@eightcap/core';
import { HttpCallModel } from '@eightcap/core';

@Injectable()
export class ErrorLogInterceptor implements HttpInterceptor {

  constructor(private errorLog: ErrorLogService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error) => {
        if (error.url.includes('event_log')) {
          return EMPTY
        } else {
          this.errorLog.startLogging({
            error,
            request
          } as HttpCallModel);
        }
        return throwError(error);
      })
    );
  }
}
